import {Button, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination} from '@mui/material';
import React, { useState } from "react";
import { LoadingButton } from "@mui/lab";
import StaffInvoicesDetailsBox from "./StaffInvoicesDetailsBox";
import StaffInvoicesDetailsBoxNew from "./StaffInvoicesDetailsBoxNew";
import FunctionsData from "../../../Functions/FunctionsData";

export default function StaffInvoicesShowTable({ dataFiltered, setDataFiltered, setLoading, setLoadingNew }) {
 
	const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const currentPageData = dataFiltered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
	
	return (
        <>
	        {/* <div style={{width:'100%', textAlign:'right'}}>
		        <Pagination count={ Math.ceil(dataFiltered.length / rowsPerPage) } variant="outlined" shape="rounded" page={page} onChange={(e,v) => setPage(v)} size="small" />
	        </div> */}
            <TableContainer>
                <Table sx={{ minWidth: 650 }} aria-label="Invoices">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">&nbsp;</TableCell>
                            <TableCell align="center">Month covered</TableCell>
                            <TableCell align="center">Invoice date</TableCell>
                            <TableCell align="center">Vet</TableCell>
                            <TableCell align="center">Vouchers</TableCell>
                            <TableCell align="center">Total</TableCell>
                            <TableCell align="center">&nbsp;</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
	                    {
							currentPageData.map((row,index) => {
                            return (
                                <ShowTableRow
                                    key={index}
                                    row={row}
                                    idx={index}
                                    dataFiltered={dataFiltered}
                                    setDataFiltered={setDataFiltered}
                                    {...{setLoading,setLoadingNew}}
                                />
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={dataFiltered.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    );
}

const ShowTableRow = ({row,setLoading,setLoadingNew, idx}) => {

    const [buttonLoading,setButtonLoading] = useState(false);
    const [isOpenRow, setIsOpenRow] = React.useState(false);
    const success = (row.msg === 'success');
    let rowDisplay = {...row};
    if(rowDisplay['vouchers'] !== null) rowDisplay['vouchers'] = rowDisplay['vouchers'].split(',') || [];

    //console.log((row.msg === 'success'), (row.msg))

    function createInvoice(vet,mth) {

        setButtonLoading(true);

        const hdr = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'token': sessionStorage.sTkn
            }
        }

        const url = '/api/merco/process_invoice/'+vet+'/all';
        fetch(FunctionsData.getApiUrl(url), hdr)
            .then((response) => response.json())
            .then(r => {

                //console.log('api/merco/process_invoice/'+vet+'/all', r);

                if(r.data[0].length > 0) {

                    console.log(r)
                    try {
                        const schedule_id = r.data[0][0]['schedule_id'];
                        if (String(schedule_id) !== 'undefined') {
                            const url2 = '/api/merco/integration/invoiced/' + schedule_id;
                            //console.log(url2, r);

                            fetch(FunctionsData.getApiUrl(url2), hdr)
                                .then((response) => response.json())
                                .then((response) => {
                                        //console.log('api/merco/integration/invoiced/', response);
                                        setTimeout(function () {
                                            setLoading(true);
                                            setLoadingNew(true);
                                        }, 5000);
                                    }
                                )
                        }
                    } catch (e) {
                        setButtonLoading(false);
                    }
                }
            })

    }

    return (
        <>
            <TableRow key={idx}>
                <TableCell align="left" style={{background: (row['invoice_done'] > 0) ? "rgba(0,255,0,0.1)" : "rgba(255,0,0,0.1)"}}>
                    {
                        (row['invoice_done'] > 0)
                            ?
                            <><strong>Invoiced #{row['id']}</strong> <br />
                                {row['schedule_id']}
                                {(success === true) ? <div style={{color:'green'}}>Synced successfully to merco</div> : <div style={{color:'red'}}>Sync with merco failed</div>}
                            </>
                            :
                            <LoadingButton loading={buttonLoading}
                                           variant={"contained"}
                                           onClick={() => createInvoice(row['vet_id'],row['reporting_month'])}>
                                Send Invoice Schedule
                            </LoadingButton>

                    }
                </TableCell>
                <TableCell align="center">{new Date(row['reporting_month']).toLocaleDateString('en-NZ')}</TableCell>
                <TableCell align="center">{(row['invoice_done'] > 0) ? new Date(row['created_at']).toLocaleDateString('en-NZ') : "Not invoiced yet."}</TableCell>
                <TableCell align="center">{row['vet_name']}</TableCell>
                <TableCell align="center">
                    {row['voucher_count']}
                </TableCell>
                <TableCell align="center">NZD {Number(row['total_amount']).toFixed(2)}</TableCell>
                <TableCell align="center">
                    <Button sx={{margin:0.5}} variant={"contained"} onClick={() => setIsOpenRow(true)}>Details</Button>
                </TableCell>
            </TableRow>
            {
                (isOpenRow) ?
                    <>
                        {
                            (row['invoice_done'] > 0) ?
                                <StaffInvoicesDetailsBox key={idx} row={rowDisplay} isOpen={isOpenRow} setIsOpen={setIsOpenRow} />
                                :
                                <StaffInvoicesDetailsBoxNew key={idx} row={rowDisplay} isOpen={isOpenRow} setIsOpen={setIsOpenRow} />
                        }
                    </>
                    : null
            }
        </>
    )
}
